import { useContext } from 'react';
import { FeatureFlagsContext } from '../context';

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}
